<template>
  <!-- prettier-ignore -->
  <div class="extendToggle">
    <ovp-button
      :key="isCompact"
      class="extendToggle__button"
      tiny
      @click="$emit('toggle')">
      <ovp-icon
        art="light"
        name="angle-down"
        :flip="isCompact ? 'horizontal' : 'vertical'"
      />
    </ovp-button>
  </div>
</template>

<script>
export default {
  name: 'ExtendToggle',

  props: {
    isCompact: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style name="mobile" scoped>
.extendToggle {
  display: inline-block;

  .extendToggle__button {
    position: absolute;
    bottom: -15px;
    left: calc(50% - 15px);
    z-index: 1;
    margin-bottom: 0;
    background-color: var(--c-white);
    border-color: var(--c-white);
    border: 1px solid var(--c-light-gray);

    width: 30px;
    min-width: 30px;
    padding: 1px 0 0 0;
  }

  .icon {
    font-size: 20px;
    color: var(--c-original-green);
  }
}
</style>
